// src/components/Curriculum/CurriculumItem.tsx
import React, { useState } from 'react';
import { Curriculum } from '../../types/interfaces'; // Import the Curriculum type
import { Card, CardContent, Typography, CardActions, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const CurriculumItem: React.FC<{ curriculum: Curriculum, onDelete: (id: number) => void }> = ({ curriculum, onDelete }) => {
  const [open, setOpen] = useState(false);

  const handleDelete = async () => {
    await onDelete(curriculum.id);
    setOpen(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h5" component="div">
          {curriculum.name}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {curriculum.description}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {curriculum.startDate} - {curriculum.endDate}
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small" component={RouterLink} to={`/curriculum/${curriculum.id}`}>
          Näytä
        </Button>
        <Button size="small" component={RouterLink} to={`/curriculum/edit/${curriculum.id}`}>
          Muokkaa
        </Button>
        <Button size="small" color="secondary" onClick={handleClickOpen}>
          Poista
        </Button>
      </CardActions>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Vahvista poisto"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Oletko varma että haluat poistaa opetusohjelman "{curriculum.name}"?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Peruuta
          </Button>
          <Button onClick={handleDelete} color="secondary" autoFocus>
            Poista
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

export default CurriculumItem;
